module.exports = __webpack_public_path__ + "img/04-7.031a6a80.png";